export const getTipLabel = (tipPercentage = null) => {
  return `Tip${tipPercentage ? ` (${tipPercentage}%)` : ''}:`;
};

export const createEmptyTipData = () => ({
  tipAmount: 0,
  tipType: null,
  tipPercentage: null,
});

export const DEFAULT_PRESET_PERCENTAGES = [10, 15, 20];

export const getPresetTipPercentages = (source = null) => {
  const configured = Array.isArray(source) ? source : source?.presetTipPercentages;

  if (!Array.isArray(configured) || configured.length === 0) {
    return DEFAULT_PRESET_PERCENTAGES;
  }

  const normalized = configured
    .map((value) => Number(value))
    .filter((value) => Number.isFinite(value) && value > 0);

  return normalized.length ? normalized : DEFAULT_PRESET_PERCENTAGES;
};

export const getTipPercentageSuffix = (tipPercentage = null) => {
  return tipPercentage ? ` (${tipPercentage}%)` : '';
};

export const getSurchargeLabel = (appliedCcSurcharge = null, fallbackName = 'CC Surcharge') => {
  const surchargeName = appliedCcSurcharge?.surchargeName || fallbackName;
  return `${surchargeName}:`;
};

export const getSurchargeName = (appliedCcSurcharge = null, fallbackName = 'CC Surcharge') => {
  return appliedCcSurcharge?.surchargeName || fallbackName;
};

// PaymentMethod enum (api/app/SG.Data.Mongo/Documents/Job/Payment.cs): Cash=0, Check=1, Card=2, Other=3, Credit=4.
const PAYMENT_METHOD_LABELS = {
  0: 'Cash', 1: 'Check', 2: 'Card', 3: 'Other', 4: 'Credit',
};

export const getDepositPaidLabel = (paymentMethod = null, formattedDate = null) => {
  const method = PAYMENT_METHOD_LABELS[paymentMethod];
  if (!method) {
    return 'Deposit paid:';
  }
  return `Deposit paid via ${method}${formattedDate ? ` on ${formattedDate}` : ''}:`;
};

export const getPaymentChargeLabel = (paymentMethod = null, formattedDate = null, isDeposit = false) => {
  const method = PAYMENT_METHOD_LABELS[paymentMethod] || 'Payment';
  const date = formattedDate ? ` on ${formattedDate}` : '';
  const deposit = isDeposit ? ' (Deposit)' : '';
  return `${method}${date}${deposit}:`;
};
